import { AppService } from "../../api";

type AppServiceKeys = "sib" | "rms-mapper" | "sdp" | "zone";

export type Environment = Record<AppServiceKeys, string>;

export let environment: Environment = {
  "rms-mapper": "",
  sib: "",
  sdp: "",
  zone: "",
};

export const updateEnvironment = (newValue: Environment) => {
  environment = {
    ...environment,
    ...newValue,
  };
};

export const convertServicesToEnvironment = (services: AppService[]) => {
  return services.reduce<Record<string, string>>((result, service) => {
    result[service.key] = service.url;
    return result;
  }, {}) as Environment;
};
